// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"64b9152c65a66bb8397d","524":"32823c89cfbf0d63ebeb","728":"4b94c3e2073e01957296"}[chunkId] + ".css";
};